export default __webpack_public_path__ + "static/media/ETH.387b2656.svg";